import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useEffect } from 'react';

const SpanPriceBlock = styled.span`
    font-size:  ${props => props.font_size || '18px'};
    font-family: Montserrat,sans-serif;
    font-weight: ${props => props.isSale ? '400' : '500'};;
    display: ${props => props.isSale ? 'inline-block' : ''};;
    margin-left: ${props => props.isSale ? '5px' : '0px'};
    color:  ${props => props.isSale ? '#999' : '#111'};
    text-decoration: ${props => props.isSale ? 'line-through' : ''}; 
    cursor: pointer;
`;
const SpanPriceDimBlock = styled.span`
    font-size:  ${props => props.font_size || '18px'};
    font-family: Montserrat,sans-serif;
    font-weight: ${props => props.isSale ? '400' : '500'};;
    display: ${props => props.isSale ? 'inline-block' : ''};;
    margin-left: ${props => props.isSale ? '5px' : '0px'};
    color:  #bbbbbb;
    text-decoration: ${props => props.isSale ? 'line-through' : ''}; 
    cursor: pointer;
`;

const SpanPrice = ({ value, isSale, fontSize = null, isDim = false }) => {

    const [curPrice, setCurPrice] = useState(null);

    let font_size = '18px';

    if (fontSize !== null) {
        font_size = fontSize;
    } else {
        if (isSale) {
            font_size = '14px';
        }
    }

    useEffect(() => {
        setCurPrice(value * 1);
    }, [value])

    if (curPrice === null || curPrice === undefined) return <SpanPriceBlock />;
    if(isDim !== null && isDim !== undefined && isDim === true) {
        return (
            <SpanPriceDimBlock isSale={isSale} font_size={font_size}>
                {Number(curPrice.toFixed(1)).toLocaleString()}
            </SpanPriceDimBlock>
        ); 
    }

    return (
        <SpanPriceBlock isSale={isSale} font_size={font_size}>
            {Number(curPrice.toFixed(1)).toLocaleString()}
        </SpanPriceBlock>
    );
};

export default SpanPrice;